import { render } from "./BaseTableDefects.vue?vue&type=template&id=7c62ffd7&scoped=true"
import script from "./BaseTableDefects.vue?vue&type=script&lang=js"
export * from "./BaseTableDefects.vue?vue&type=script&lang=js"

import "./BaseTableDefects.vue?vue&type=style&index=0&id=7c62ffd7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c62ffd7"]])

export default __exports__